import S01_1 from '../assets/newDoorNormalMaps/S01/0000..0000.png'
import S01_2 from '../assets/newDoorNormalMaps/S01/0000..0001.png'
import S01_3 from '../assets/newDoorNormalMaps/S01/0000..0002.png'
import S01_4 from '../assets/newDoorNormalMaps/S01/0000..0003.png'
import S01_5 from '../assets/newDoorNormalMaps/S01/0000..0004.png'
import S01_6 from '../assets/newDoorNormalMaps/S01/0000..0005.png'
import S01_7 from '../assets/newDoorNormalMaps/S01/0000..0006.png'
import S01_8 from '../assets/newDoorNormalMaps/S01/0000..0007.png'

import S04_1 from '../assets/newDoorNormalMaps/S04/0000..0000.png'
import S04_2 from '../assets/newDoorNormalMaps/S04/0000..0001.png'
import S04_3 from '../assets/newDoorNormalMaps/S04/0000..0002.png'
import S04_4 from '../assets/newDoorNormalMaps/S04/0000..0003.png'
import S04_5 from '../assets/newDoorNormalMaps/S04/0000..0004.png'
import S04_6 from '../assets/newDoorNormalMaps/S04/0000..0005.png'
import S04_7 from '../assets/newDoorNormalMaps/S04/0000..0006.png'
import S04_8 from '../assets/newDoorNormalMaps/S04/0000..0007.png'

import B200R203_1 from '../assets/newDoorNormalMaps/B200R203/0000..0000.png'
import B200R203_2 from '../assets/newDoorNormalMaps/B200R203/0000..0001.png'
import B200R203_3 from '../assets/newDoorNormalMaps/B200R203/0000..0002.png'
import B200R203_4 from '../assets/newDoorNormalMaps/B200R203/0000..0003.png'
import B200R203_5 from '../assets/newDoorNormalMaps/B200R203/0000..0004.png'
import B200R203_6 from '../assets/newDoorNormalMaps/B200R203/0000..0005.png'
import B200R203_7 from '../assets/newDoorNormalMaps/B200R203/0000..0006.png'
import B200R203_8 from '../assets/newDoorNormalMaps/B200R203/0000..0007.png'

import B200R401_1 from '../assets/newDoorNormalMaps/B200R401/0000..0000.png'
import B200R401_2 from '../assets/newDoorNormalMaps/B200R401/0000..0001.png'
import B200R401_3 from '../assets/newDoorNormalMaps/B200R401/0000..0002.png'
import B200R401_4 from '../assets/newDoorNormalMaps/B200R401/0000..0003.png'
import B200R401_5 from '../assets/newDoorNormalMaps/B200R401/0000..0004.png'
import B200R401_6 from '../assets/newDoorNormalMaps/B200R401/0000..0005.png'
import B200R401_7 from '../assets/newDoorNormalMaps/B200R401/0000..0006.png'
import B200R401_8 from '../assets/newDoorNormalMaps/B200R401/0000..0007.png'

import B200R500_1 from '../assets/newDoorNormalMaps/B200R500/0000..0000.png'
import B200R500_2 from '../assets/newDoorNormalMaps/B200R500/0000..0001.png'
import B200R500_3 from '../assets/newDoorNormalMaps/B200R500/0000..0002.png'
import B200R500_4 from '../assets/newDoorNormalMaps/B200R500/0000..0003.png'
import B200R500_5 from '../assets/newDoorNormalMaps/B200R500/0000..0004.png'
import B200R500_6 from '../assets/newDoorNormalMaps/B200R500/0000..0005.png'
import B200R500_7 from '../assets/newDoorNormalMaps/B200R500/0000..0006.png'
import B200R500_8 from '../assets/newDoorNormalMaps/B200R500/0000..0007.png'

import B600R100_1 from '../assets/newDoorNormalMaps/B600R100/0000..0000.png'
import B600R100_2 from '../assets/newDoorNormalMaps/B600R100/0000..0001.png'
import B600R100_3 from '../assets/newDoorNormalMaps/B600R100/0000..0002.png'
import B600R100_4 from '../assets/newDoorNormalMaps/B600R100/0000..0003.png'
import B600R100_5 from '../assets/newDoorNormalMaps/B600R100/0000..0004.png'
import B600R100_6 from '../assets/newDoorNormalMaps/B600R100/0000..0005.png'
import B600R100_7 from '../assets/newDoorNormalMaps/B600R100/0000..0006.png'
import B600R100_8 from '../assets/newDoorNormalMaps/B600R100/0000..0007.png'

import B600R102_1 from '../assets/newDoorNormalMaps/B600R102/0000..0000.png'
import B600R102_2 from '../assets/newDoorNormalMaps/B600R102/0000..0001.png'
import B600R102_3 from '../assets/newDoorNormalMaps/B600R102/0000..0002.png'
import B600R102_4 from '../assets/newDoorNormalMaps/B600R102/0000..0003.png'
import B600R102_5 from '../assets/newDoorNormalMaps/B600R102/0000..0004.png'
import B600R102_6 from '../assets/newDoorNormalMaps/B600R102/0000..0005.png'
import B600R102_7 from '../assets/newDoorNormalMaps/B600R102/0000..0006.png'
import B600R102_8 from '../assets/newDoorNormalMaps/B600R102/0000..0007.png'

import B602R102_9 from '../assets/newDoorNormalMaps/B602R102/bumpRound.png'

export const newDoorNormalMapsUrls = {
  S01: [S01_1, S01_2, S01_3, S01_4, S01_5, S01_6, S01_7, S01_8],
  S04: [S04_1, S04_2, S04_3, S04_4, S04_5, S04_6, S04_7, S04_8],
  B200R203: [
    B200R203_1,
    B200R203_2,
    B200R203_3,
    B200R203_4,
    B200R203_5,
    B200R203_6,
    B200R203_7,
    B200R203_8,
  ],
  B200R401: [
    B200R401_1,
    B200R401_2,
    B200R401_3,
    B200R401_4,
    B200R401_5,
    B200R401_6,
    B200R401_7,
    B200R401_8,
  ],
  B200R500: [
    B200R500_1,
    B200R500_2,
    B200R500_3,
    B200R500_4,
    B200R500_5,
    B200R500_6,
    B200R500_7,
    B200R500_8,
  ],
  B600R100: [
    B600R100_1,
    B600R100_2,
    B600R100_3,
    B600R100_4,
    B600R100_5,
    B600R100_6,
    B600R100_7,
    B600R100_8,
  ],
  B600R102: [
    B600R102_1,
    B600R102_2,
    B600R102_3,
    B600R102_4,
    B600R102_5,
    B600R102_6,
    B600R102_7,
    B600R102_8,
  ],
  B602R102: [
    B600R102_1,
    B600R102_2,
    B600R102_3,
    B600R102_4,
    B600R102_5,
    B600R102_6,
    B600R102_7,
    B600R102_8,
    B602R102_9,
  ],
  B100R000: ['', '', '', '', '', '', '', '', ''],
}
